<!--统计弹层-->
<template>
    <div  class="statistics-dialog">
        <el-dialog
            :title="modelTitle"
            :visible.sync="show"
            width="450px"
            :before-close="handleClose">
            <slot name="content"></slot>
            <span slot="footer" class="dialog-footer">
                <el-button @click.native="onClick('cancel',$event)" v-if='cancel'  class="cancel-btn">{{cancel}}</el-button>
                <el-button @click.native="onClick('ok',$event)" v-if='ok' type="primary" class="medical-btn">{{ok}}</el-button>
            </span>
        </el-dialog>
    </div>
    
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    props: ['cancel','ok','show'],
    data() {
      return {
        //add_dialogVisible: true
      };
    },
    computed: {
        ...mapState({
            modelTitle:state=>state.excavate.modelTitle,
        })
    },
    methods: {
        
        onClick (msg,e) {
            if(msg=='cancel'){
                this.$emit('update:show',false)
            }else{
                this.$emit(msg,e);
            }
            
        },
        handleClose() {
            this.$emit('update:show',false)
            // this.$emit('cancel');
        },
    }
  };
</script>
    
<style lang='less' scoped>
.statistics-dialog /deep/ .el-dialog__header{
        line-height: 24px;
        background-color:  #409EFF;
        font-size: 18px;
        padding: 10px 20px;
        .el-dialog__title{
            color: #fff;
        }
    }
 .statistics-dialog /deep/  .el-dialog__header{
    line-height: 24px;
    background-color:  #409EFF;
    font-size: 18px;
    padding: 10px 20px;
    .el-dialog__title{
        color: #fff;
    }
}
.statistics-dialog /deep/ .el-dialog__headerbtn{
    top:12px;
    .el-dialog__close{
        color: #fff !important;
    }
    
}
.statistics-dialog /deep/ .el-dialog__body,.el-dialog__footer{
    // background: #fff !important;
}
.statistics-dialog /deep/ .el-dialog__body{
    padding: 20px !important;
}
.statistics-dialog /deep/ .el-dialog__footer{
    padding-top: 0;
}
.statistics-dialog  /deep/ .cont{
    display: flex;
    justify-content: space-evenly;
}
</style>